import React from 'react';
import PositionTextListItemVO from '@domain/vo/common/PositionTextListItemVO';

import PositionTextListItem from '@components/common/positionTextListItem';
import classnames from 'classnames/bind';
import styles from './positionChallengeList.module.scss';
const cx = classnames.bind(styles);

interface PositionChallengeListProps {
  positions: PositionTextListItemVO[];
  setModalVisible: (modalVisible: boolean) => void;
}

const PositionChallengeList = ({ positions, setModalVisible }: PositionChallengeListProps) => {
  if (!positions) return null;

  if (!positions || positions.length === 0) return null;

  const positionCount = positions?.length ?? 0;
  const positionEls = positions?.slice(0, 6).map((positionChallenge, i) => {
    return (
      <li className={cx('listItem')} key={i}>
        <PositionTextListItem positionData={positionChallenge} />
      </li>
    );
  });

  return (
    <div className={cx('positionCompanyArea')}>
      <ul className={cx('positionCompanyList')}>{positionEls}</ul>
      {positionCount > 0 && (
        <div className={cx('btnMoreArea')}>
          <a className={cx('btnMore')} role="button" onClick={() => setModalVisible(true)}>
            {positionCount}개 포지션 모두보기
          </a>
        </div>
      )}
    </div>
  );
};

export default PositionChallengeList;
